import { render, staticRenderFns } from "./coordinate.vue?vue&type=template&id=7e9f33ae&scoped=true"
import script from "./coordinate.vue?vue&type=script&lang=js"
export * from "./coordinate.vue?vue&type=script&lang=js"
import style1 from "./coordinate.vue?vue&type=style&index=1&id=7e9f33ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9f33ae",
  null
  
)

export default component.exports